import React from 'react';
import { BlockTypeButton } from './BlockTypeButton';

const BLOCK_TYPE_MAP = {
	h1: ['header-one', '一级标题'],
	h2: ['header-two', '二级标题'],
	h3: ['header-three', '三级标题'],
	h4: ['header-four', '四级标题'],
	h5: ['header-five', '五级标题'],
	h6: ['header-six', '六级标题'],
};

export const createHeadingButton = heading => {
	const [blockType, title] = BLOCK_TYPE_MAP[heading];
	function HeadingBlockButton({ store, theme, disabled }) {
		return (
			<BlockTypeButton store={store} theme={theme} disabled={disabled} blockType={blockType}>
				<i className={"qa-ico-" + heading} title={title}>{heading}</i>
			</BlockTypeButton>
		);
	}
	return HeadingBlockButton;
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/blockStylePlugin/HeadingBlockButton.jsx